import { render, staticRenderFns } from "./HpadPD_Total.vue?vue&type=template&id=5e8510d8"
import script from "./HpadPD_Total.vue?vue&type=script&lang=js"
export * from "./HpadPD_Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports